// R30 #5 → R116 #1 (Skeptic M1): the shared company login (Marina's crew,
// Fido) asks who is actually working, once per device. It is the first thing
// a shared login sees after signing in, so it rides the same "Welcome home"
// shell over the boot splash. No dismiss — attribution is the whole point.
// Resolves with the trimmed name (≤ 60 chars); tears its stage down first so
// nothing of the sign-in look leaks into the app that renders next.
import { authCardHtml, alertHtml, fieldHtml, submitHtml, esc, bindMarkLight, showAlert, clearAlertOnInput } from './AuthShell';
import { mountAuthFx } from './authFx';

export function promptSharedPerson(company: string): Promise<string> {
  return new Promise(resolve => {
    const destroyFx = mountAuthFx();
    const host = document.createElement('div');
    host.innerHTML = authCardHtml({
      screen: 'who',
      compactBrand: true,
      hello: "<b>Who's working on this device?</b>",
      helper: `This is the shared <b>${esc(company)}</b> login — enter your name so your inspections, issues and photos are credited to you. Asked once per device.`,
      body: `
        ${alertHtml('shared-person-err')}
        <form id="shared-person-form" novalidate>
          ${fieldHtml({ id: 'shared-person-in', label: 'Your name', type: 'text', name: 'name', autocomplete: 'name', placeholder: 'First and last name', extra: 'maxlength="60" autocapitalize="words"' })}
          ${submitHtml('shared-person-go', 'Start working')}
        </form>`,
    });
    const wrap = host.firstElementChild as HTMLElement;
    wrap.classList.add('au-overlay');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-label', "Who's working on this device?");
    document.body.appendChild(wrap);
    const card = wrap.querySelector('.au-card') as HTMLElement;
    const inp = wrap.querySelector('#shared-person-in') as HTMLInputElement;
    const err = wrap.querySelector('#shared-person-err') as HTMLElement;
    bindMarkLight(card, [inp]);
    clearAlertOnInput(err, [inp]);
    const go = (e?: Event) => {
      e?.preventDefault();
      const v = (inp.value || '').trim().slice(0, 60);
      if (!v) { showAlert(err, 'Enter your name to start.', [inp]); inp.focus(); return; }
      wrap.remove();
      destroyFx();
      resolve(v);
    };
    wrap.querySelector('#shared-person-form')?.addEventListener('submit', go);
    inp.focus();
  });
}
